import React from "react";
import { Link, useLocation } from "react-router-dom";

type PreviewState = {
  title?: string;
  description?: string;
  members?: string[];
};

export default function GroupTalkPreview() {
  const location = useLocation();
  const state = (typeof location.state === "object" && location.state ? location.state : {}) as PreviewState;
  const title = state.title || "会議メンバー";
  const description = state.description || "選んだメンバーで相談を始める前の確認画面です。";
  const members = state.members && state.members.length > 0 ? state.members : ["メイ"];

  return (
    <main className="min-h-screen overflow-x-hidden bg-[radial-gradient(circle_at_top,_rgba(250,233,220,0.95),_rgba(255,249,245,1)_55%)] px-4 py-6 text-[#4A3E39] sm:px-6 sm:py-10">
      <div className="mx-auto w-full max-w-xl">
        <header className="mb-6 flex items-center justify-between">
          <Link to="/talk/group" className="text-sm font-bold text-[#A67C52] hover:text-[#7C5A4E]">
            ← 戻る
          </Link>
          <p className="text-sm font-bold tracking-tight text-[#7C5A4E]">開始前の確認</p>
          <span className="text-xs text-[#9C867D]">Mock</span>
        </header>

        <section className="rounded-[2.4rem] border border-white/80 bg-white/90 p-6 shadow-[0_24px_60px_rgba(124,90,78,0.16)] backdrop-blur-sm sm:p-7">
          <span className="inline-flex rounded-full bg-[#FFF3E9] px-3 py-1 text-[11px] font-black text-[#A46D4C]">準備中</span>
          <h1 className="mt-4 text-3xl font-black tracking-tight text-[#7C5A4E]">{title}</h1>
          <p className="mt-3 text-sm leading-7 text-[#6B5851]">{description}</p>

          <div className="mt-8 rounded-[2rem] border border-[#EADBC8] bg-[#FFFBF8] p-5">
            <p className="text-sm font-black text-[#5D4D46]">参加メンバー</p>
            <div className="mt-3 flex flex-wrap gap-2">
              {members.map((member) => (
                <span
                  key={member}
                  className="rounded-full border border-[#D9C5B9] bg-white px-3 py-1.5 text-sm font-bold text-[#5D4D46]"
                >
                  {member}
                </span>
              ))}
            </div>

            <div className="mt-6 rounded-[1.6rem] border border-dashed border-[#D9C5B9] bg-white/70 p-4 text-sm leading-6 text-[#6B5851]">
              実際の複数人会話はまだ未実装です。ここでは、会議の型と参加メンバーを選び、開始直前までの流れを確認できます。
            </div>
          </div>

          <div className="mt-8 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
            <Link
              to="/talk/group"
              className="rounded-full border border-[#EADBC8] bg-white px-5 py-3 text-center text-sm font-bold text-[#5D4D46]"
            >
              メンバーを調整する
            </Link>
            <button
              type="button"
              disabled={true}
              className="rounded-full bg-[#C9B8AF] px-6 py-3 text-sm font-black text-white"
            >
              このメンバーで始める（準備中）
            </button>
          </div>
        </section>
      </div>
    </main>
  );
}
